import { serverTimestamp } from 'firebase/firestore';
import { convertHelpers } from 'global/common/convert';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Form } from 'semantic-ui-react';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import AppForm from '../../../global/components/forms/appForms/AppForm';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { getCourseHandicapIndex } from '../golfCalcs/courseHandicap';
import { dropDown_golfCourse } from '../helpers/golfElements';
import { golfAppForms } from '../helpers/golfFormProps';
import { _allowGolferUpdates, useGolfers } from '../useHelpers/useGolfers';
import { handicapRowModes } from './GolferRow';

const GolferHandicap = (props) => {

  const { golfer, handicapRowMode, showTeebox, handleCancel } = props
  const { firstName, lastName, _itemKey } = golfer ?? {}

  const { update_eventGolfer, update_tournamentGolfer, handleUpdate_tournamentGolfersHandicaps, updating } = useGolfers()

  console.log('handicapRowMode', handicapRowMode)

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states } = golfParent_contexts ?? {}
  const { golfEvent_state, golfTournament_state } = states ?? {}

  // golfEvent_state 
  const { golfers: golfers_event } = golfEvent_state ?? {}

  // golfTournament_state 
  const { details, tournamentGolfCourses, golfTournament } = golfTournament_state ?? {}
  const { golfers: golfers_tournament } = details ?? {}

  // local state 
  const tgc = _.first(_.values(tournamentGolfCourses))

  const [courseCount] = useState(tournamentGolfCourses ? Object.keys(tournamentGolfCourses).length : 10)
  // this does not change
  const [existingHandicapIndex, setExistingHandicapIndex] = useState()
  const [saveCaption, setSaveCaption] = useState()
  const [saveCaption2, setSaveCaption2] = useState()
  const [saveHcpCaption, setSaveHcpCaption] = useState('Update Handicap')
  const [currentGolfer, setCurrentGolfer] = useState()

  const replaceGolferCourseKey = (golfer, newKey) => {
    const replaceKey = (obj) => {
      const value = _.first(_.values(obj))
      return {
        [newKey]: value
      }
    }

    return {
      ...golfer,
      courseHandicapIndexes: replaceKey(golfer.courseHandicapIndexes),
      courseHandicaps: replaceKey(golfer.courseHandicaps),
      courseTeeboxes: replaceKey(golfer.courseTeeboxes),
    }
  }

  const { handicapFormItems, selectedGolfer, _golferCourseHandicaps, _golferCourseTeeboxes } = useMemo(() => {

    let _formProps;
    let _golfer;

    if (golfer) {

      const { _itemKey } = golfer
      const golfer_event = golfers_event[_itemKey]

      switch (handicapRowMode) {
        case handicapRowModes.handicapIndex:
          _golfer = golfer
          _formProps = golfAppForms().handicapIndex
          break;

        case handicapRowModes.tournamentHandicapIndex:
          _golfer = _.merge(golfer, golfer_event)
          _formProps = golfAppForms().tournamentHandicapIndex
          break;

        case handicapRowModes.courseHandicap:
          _golfer = _.merge(golfer, golfer_event)
          _formProps = golfAppForms().courseHandicap
          break;

        case handicapRowModes.golfer:
          _golfer = golfer
          _formProps = golfAppForms().golfer
          break;

        default:
        // nothing
      }
    }

    const { handicapIndex } = _golfer ?? {}
    let _handicapIndex = handicapIndex ? handicapIndex : 100
    if (_handicapIndex && _handicapIndex.toString().indexOf('.') < 0) { _handicapIndex = _handicapIndex + '.0' }
    _golfer.handicapIndex = convertHelpers.convertStringValue(_handicapIndex)

    const { courseHandicaps, courseTeeboxes } = _golfer ?? {}

    return {
      selectedGolfer: _golfer,
      handicapFormItems: _formProps,
      _golferCourseHandicaps: courseHandicaps,
      _golferCourseTeeboxes: courseTeeboxes
    }
  }, [golfer])

  const { handicapIndex, handicapSourceType, tournamentHandicapIndex, email, phoneNumber, allowLineupModification, _dateProps } = currentGolfer ?? {}

  // init
  const allowUpdate = useMemo(() => {

    let _allowUpdate = false

    switch (handicapRowMode) {
      case handicapRowModes.handicapIndex:
        if (handicapIndex && handicapSourceType) {
          _allowUpdate = true
        }
        break;

      case handicapRowModes.tournamentHandicapIndex:
        if (handicapIndex && handicapSourceType) {
          _allowUpdate = true
        }
        break;

      case handicapRowModes.courseHandicap:
        console.log('currentGolfer', currentGolfer?.courseTeeboxes)
        if ((_.size(currentGolfer?.courseTeeboxes) === courseCount) && (_.size(currentGolfer?.courseHandicaps) === courseCount)) {
          _allowUpdate = true
        }
        break;
      default:
      // nothing
    }
    return _allowUpdate
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentGolfer, courseCount, handicapIndex, handicapSourceType]);

  // init
  useEffect(() => {
    if (selectedGolfer) {
      setCurrentGolfer(selectedGolfer)
      setExistingHandicapIndex(selectedGolfer?.handicapIndex)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedGolfer]);

  // init
  useEffect(() => {

    if (currentGolfer) {

      let _caption;
      let _caption2 = firstName + ' ' + lastName

      switch (handicapRowMode) {
        case handicapRowModes.handicapIndex:
          _caption = 'Update Handicap Index'
          break;

        case handicapRowModes.tournamentHandicapIndex:
        case handicapRowModes.courseHandicap:
          if (handicapRowMode === handicapRowModes.tournamentHandicapIndex) {
            _caption = 'Update Tournament Handicap Index'
            _caption2 += ' - Tournament'
            setSaveHcpCaption(_caption)
          } else {
            _caption = 'Update Tee Box'
            setSaveHcpCaption(_caption)
            _caption2 += ' - Tournament'
          }
          break;

        default:
        // nothing
      }

      setSaveCaption(_caption2)
      setSaveCaption2(_caption + ' (' + existingHandicapIndex + ') (' + _itemKey + ')')

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentGolfer]);

  const handleLocalPropChange = (d) => setCurrentGolfer(d)
  const form_handlers = { handleFormDataChange_parent: handleLocalPropChange }

  const appForm_handicap = () => <AppForm
    data_parent={currentGolfer}
    appFormItems={handicapFormItems}
    form_handlers={form_handlers}
  />

  const getCourseTeeboxRatings = (gk, teebox) => {
    const gc = tournamentGolfCourses[gk]
    const { teeBoxes: roundTeeBoxes, holes } = gc ? gc : {}
    if (roundTeeBoxes && roundTeeBoxes[teebox]) {
      return { ratings: roundTeeBoxes[teebox], holes }
    }
  }

  const getPar = (holes) => {
    let _par = 0
    if (holes) {
      Object.keys(holes).forEach(hKey => {
        _par += parseInt(holes[hKey].par)
      })
    }
    return _par
  }

  const calcGolfersCourseTeeboxHandicap = () => {
    const _golfers_tournament = _.cloneDeep(golfers_tournament)
    if (_golfers_tournament && currentGolfer) {
      const { courseTeeboxes } = currentGolfer
      _.forEach(tournamentGolfCourses, (tournamentGolfCourse, gck) => {
        if (courseTeeboxes[gck]) {
          const courseTeebox = courseTeeboxes[gck]
          const { ratings, holes } = getCourseTeeboxRatings(gck, courseTeebox)
          _.forEach(_golfers_tournament, (g, gKey) => {
            const { handicapIndex: handicapIndex_tournament } = g ?? {}

            // let { courseHandicaps, courseHandicapIndexes, courseTeeboxes } = g ?? {}

            if (handicapIndex_tournament) {

              g.tournamentHandicapIndex = handicapIndex_tournament

              const { rating, slope } = ratings ? ratings : {}
              const par = getPar(holes)

              const { courseHandicap, courseHandicapIndex } = getCourseHandicapIndex(handicapIndex_tournament, rating, slope, par)

              const gt = {
                courseHandicapIndexes: {},
                courseHandicaps: {},
                courseTeeboxes: {},
              }

              gt.courseHandicaps[gck] = courseHandicap
              gt.courseHandicapIndexes[gck] = courseHandicapIndex
              gt.courseTeeboxes[gck] = courseTeebox
              _.merge(g, gt)

            }
          })
        }
      })
    }
    return _golfers_tournament
  }

  /**
   * Handles the change in the golf tournament tee box
   * @param {*} e 
   * @param {*} data 
   */
  const handleGolfCourseTeeboxChange = (gck, selectedTeeBox) => {
    const _currentGolfer = _.cloneDeep(currentGolfer)
    const { handicapIndex } = _currentGolfer ?? {}
    const tgc = tournamentGolfCourses?.[gck]
    const { teeBoxes, holes } = tgc ?? {}
    const ratings = teeBoxes?.[selectedTeeBox]
    const par = getPar(holes)
    const courseHandicaps = getCourseHandicapIndex(handicapIndex, ratings.rating, ratings.slope, par)
    const { courseHandicap, courseHandicapIndex } = courseHandicaps ?? {}

    _currentGolfer.courseTeeboxes ??= {}
    _currentGolfer.courseHandicaps ??= {}
    _currentGolfer.courseHandicapIndexes ??= {}

    _currentGolfer.courseTeeboxes[gck] = selectedTeeBox
    _currentGolfer.courseHandicaps[gck] = courseHandicap
    _currentGolfer.courseHandicapIndexes[gck] = courseHandicapIndex

    setCurrentGolfer(_currentGolfer)
  }

  const handleViewAuth = () => {

  }

  /** Saves the handicap to the database (event or tournament) */
  const handleUpdate_handicap = () => {

    const _golferToUpdate = {
      _itemKey: currentGolfer._itemKey,
      _updateDate: serverTimestamp(),
      previousHandicapIndexes: currentGolfer.previousHandicapIndexes ?? []
    };

    switch (handicapRowMode) {
      case handicapRowModes.handicapIndex:
        _golferToUpdate.previousHandicapIndexes.push(existingHandicapIndex)
        _golferToUpdate.handicapIndex = handicapIndex
        _golferToUpdate.handicapSourceType = handicapSourceType
        if (phoneNumber) {
          _golferToUpdate.phoneNumber = phoneNumber
        }
        if (email) {
          _golferToUpdate.email = email
        }
        update_eventGolfer({ golfer: _golferToUpdate })
        // golfEvent_handlers.handleUpdate_eventGolfer(_golferToUpdate)
        handleCancel()
        break;

      case handicapRowModes.tournamentHandicapIndex:
        _golferToUpdate.tournamentHandicapIndex = tournamentHandicapIndex
        if (allowLineupModification) {
          _golferToUpdate.allowLineupModification = allowLineupModification
        }
        update_tournamentGolfer({ golfTournament, golfer: _golferToUpdate })
        // golfTournament_handlers.handleUpdate_tournamentGolfer(_golferToUpdate)
        handleCancel()
        break;

      case handicapRowModes.courseHandicap:
        // _golferToUpdate.courseHandicaps = golferCourseHandicaps
        // _golferToUpdate.courseTeeboxes = golferCourseTeeboxes
        update_tournamentGolfer({ golfTournament, golfer: currentGolfer })
        // golfTournament_handlers.handleUpdate_tournamentGolfer(_golferToUpdate)
        handleCancel()
        break;

      default:
      // nothing
    }
  }

  const handleSave_allTeeboxes = () => {
    const _glfs = calcGolfersCourseTeeboxHandicap()
    handleUpdate_tournamentGolfersHandicaps({ golfers: _glfs })
  }

  const handleSave_golferTeeboxes = () => {
    const newGolfersTournament = _.mapValues(
      golfers_tournament,
      (golfer) => replaceGolferCourseKey(golfer, tgc?._itemKey)
    )
    console.log('newGolfersTournament', newGolfersTournament)
    handleUpdate_tournamentGolfersHandicaps({ golfers: newGolfersTournament })
  }

  /**
   * 
   * @returns a dropdown for each tournament golf course
   */
  const tournamentCourses = useMemo(() => {
    if (!tournamentGolfCourses) return []
    convertHelpers.createItemKeys(tournamentGolfCourses)
    return _.map(tournamentGolfCourses, (tgc) =>
      dropDown_golfCourse(tgc, currentGolfer, 'position3', handleGolfCourseTeeboxChange)
    )
  }, [currentGolfer, tournamentGolfCourses])

  const form_handicap = () => {
    switch (handicapRowMode) {
      case handicapRowModes.handicapIndex:
        return appForm_handicap()
      case handicapRowModes.tournamentHandicapIndex:
        return appForm_handicap()
      case handicapRowModes.courseHandicap:
        return <div>
          {appForm_handicap()}
          {showTeebox && <Form style={{ paddingTop: '1em' }}>
            {tournamentCourses}
          </Form>}
        </div>
      default:
      // nothing
    }
  }

  const handicapFooter = () => {

    const btns = []

    switch (handicapRowMode) {
      case handicapRowModes.handicapIndex:
        btns.push({ oc: handleUpdate_handicap, icon: 'save', caption: 'Update ' + _.startCase(handicapRowMode), disabled: !allowUpdate, color: _allowGolferUpdates ? 'green' : 'teal' })
        break;
      case handicapRowModes.tournamentHandicapIndex:
        btns.push({ oc: handleUpdate_handicap, icon: 'save', caption: 'Update ' + _.startCase(handicapRowMode), disabled: !allowUpdate, color: _allowGolferUpdates ? 'green' : 'teal' })
        break;
      case handicapRowModes.courseHandicap:
        btns.push({ oc: handleUpdate_handicap, icon: 'save', caption: 'Update TB', disabled: !allowUpdate, color: _allowGolferUpdates ? 'green' : 'teal' })
        btns.push({ caption: 'Update All', oc: handleSave_allTeeboxes, icon: 'save', disabled: !allowUpdate, color: _allowGolferUpdates ? 'green' : 'teal' })
        // btns.push({ caption: 'Update GC', oc: handleSave_golferTeeboxes, icon: 'save', color: _allowGolferUpdates ? 'green' : 'teal' })

        break;
      default:
      // nothing
    }

    btns.push({ oc: handleViewAuth, icon: 'user', caption: 'Auth', color: 'blue', fl: true })

    return <UiSaveButtons others={btns} />
  }

  const wrapper_handicap = () => <Wrapper
    content={currentGolfer && handicapFormItems && form_handicap()}
    footer={handicapFooter()}
    updating={updating}
    wrapperType={wrapperTypes.padded}
  />

  const fpw_handicap = () => <FullPageWrapper
    content={wrapper_handicap()}
    handleCancel={handleCancel}
    topperCaption={saveCaption}
    topperCaption2={saveCaption2}
    css={{ container: 'app-dark-mode' }}
  />

  return fpw_handicap()
}

export default GolferHandicap